<template>
  <div class="sub-menu">
    <template
      v-for="item in props.menus"
      :key="`${props.basePath}/${item.path}`"
    >
    <a-sub-menu v-if="item.children && item.children.length>0">
        <template #title>
            <span>{{ item.meta.title }}</span>
        </template>
        <SubMenu :menus="item.children"/>
    </a-sub-menu>
    <template v-else>
        <a-menu-item :key="`${props.basePath}/${item.path}`">
            {{ item.meta.title }}
        </a-menu-item>
    </template>
    </template>
  </div>
</template>
<script setup>
import {defineProps} from "vue"
const props = defineProps(["menus","basePath"])
console.log('----',props.menus)
</script>